import { Component } from '@angular/core';

@Component({
  selector: 'app-legal-disclaimer',
  templateUrl: './legal-disclaimer.component.html',
  styleUrl: './legal-disclaimer.component.scss'
})
export class LegalDisclaimerComponent {

}
